import React from "react";
import { useCart } from "../components/cart-components/CartContext";
import QuantityButton from "../components/cart-components/QuantityButton";
import RemoveButton from "../components/cart-components/RemoveButton";
import ClearCartButton from "../components/cart-components/ClearCartButton";
import CheckoutButton from "../components/cart-components/CheckoutButton";
import "../styles.css";

const Cartpage = () => {
  const { cartItems } = useCart();
  const { totalPrice } = useCart();

  if (cartItems.length === 0) {
    return (
      <div className="page-content">
        <h2>Your Cart</h2>
        <p>
          Your cart is currently empty. You must have an account to use the cart
          feature.
        </p>
      </div>
    );
  }

  return (
    <div className="page-content">
      <h2>Your Cart</h2>
      <p>
        Proceeding to Checkout will send and create a Purchase Order to our
        orders team. This will be processed (usually no more than 2 working
        days) and you'll recieve an order acknowledgement by email. No payment
        will take place via our website at this time.{" "}
      </p>
      <ul className="cart-list">
        {cartItems.map((item) => (
          <li
            key={`${item.id}-${item.fabric}-${item.rangeModel}-${item.optionalExtras}`}
            className="cart-item"
          >
            <div className="cartitem-image">
              <img src={item.rangeImg} alt={item.name} />
            </div>
            <div className="item-details">
              <div className="cartitem-actions">
                <QuantityButton item={item} />
                <RemoveButton item={item} />
              </div>
              <p>
                <b>Product:</b> {item.rangeModel}
              </p>
              <p>
                <b>Fabric:</b> {item.fabric}
              </p>

              <p>
                <b>Optional Extras:</b> {item.optionalExtras || "None"}
              </p>
              <p>
                <b>Quantity:</b> {item.quantity}
              </p>
              <p>
                <b>£{(item.price * item.quantity).toFixed(2)} </b>
              </p>
            </div>
          </li>
        ))}
      </ul>
      <div className="cart-total">
        <p>
          <b>Order Total</b>
        </p>
        <p>
          <b>{`£${totalPrice}`}</b>
        </p>
      </div>
      <div className="cart-actions">
        <CheckoutButton />
      </div>
      <div className="cart-actions">
        <ClearCartButton />
      </div>
    </div>
  );
};

export default Cartpage;
